class ProductQuantityModal extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'modal', 'close']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )

    this.listeners.add(this.els.backdrop.element, 'click', () =>
      this.closeModal(),
    )

    this.listeners.add(this.els.close.element, 'click', () => this.closeModal())
  }

  onTriggerClick (event) {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'false')

    document.body.style.setProperty('overflow', 'hidden')
    document.querySelector('.hd-Header').classList.add('hd-Header-modalOpen')
    event.preventDefault()
  }

  closeModal () {
    this.els?.modal?.element?.setAttribute('aria-hidden', 'true')

    document.body.style.removeProperty('overflow')
    document.querySelector('.hd-Header').classList.remove('hd-Header-modalOpen')
  }
}

if (!window.customElements.get('product-quantity-modal')) {
  window.customElements.define('product-quantity-modal', ProductQuantityModal)
}
